// extracted by mini-css-extract-plugin
module.exports = {"check-boxes":"CheckBox_check-boxes__1GIv4","checkCustom":"CheckBox_checkCustom__3ieOE","checkmark":"CheckBox_checkmark__M4vJN"};